import Mark from 'mark.js';
import debounce from '../utilities/debounce';

export default function PriceLists(el) {
    const searchForm = el.querySelector('form[method="get"]');
    const searchInput = searchForm.querySelector('input[type="search"]');
    const [resultReset, emptyReset] = el.querySelectorAll('button[type="reset"]');
    const resultMessage = resultReset.closest('p');
    const resultTag = resultMessage.querySelector('em');
    const emptyMessage = emptyReset.closest('header');
    const emptyTag = emptyMessage.querySelector('em');
    const accordions = el.querySelectorAll('details');
    const marks = [...accordions].map(s => new Mark(s));

    const divisionTabs = el.querySelectorAll('[data-division-tab]');
    const divisionPanels = el.querySelectorAll('[data-division-panel]');

    divisionTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const targetSlug = tab.getAttribute('data-division-tab');
            divisionTabs.forEach(t => {
                const isActive = t === tab;
                t.classList.toggle('is-active', isActive);
                t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            divisionPanels.forEach(panel => {
                panel.hidden = panel.getAttribute('data-division-panel') !== targetSlug;
            });
        });
    });

    searchInput.onkeyup = debounce(() => {
        const { value } = searchInput;

        if (value === '') {
            resultMessage.style.display = 'none';
            emptyMessage.style.display = 'none';
            accordions.forEach(a => {
                a.style.display = 'block';
                a.removeAttribute('open');
            });
            marks.forEach(m => {
                m.unmark();
            });

            // Restore active division panel visibility
            const activeTab = el.querySelector('[data-division-tab].is-active');
            const activeSlug = activeTab ? activeTab.getAttribute('data-division-tab') : null;
            divisionPanels.forEach(panel => {
                panel.hidden = activeSlug ? panel.getAttribute('data-division-panel') !== activeSlug : false;
            });

            return;
        }

        let resultsCount = 0;
        const matched = [];
        const nomatched = [];

        resultMessage.style.display = 'none';
        emptyMessage.style.display = 'none';
        accordions.forEach((a, i) => {
            a.style.display = 'none';
            a.removeAttribute('open');
            marks[i].unmark({
                done: () => {
                    marks[i].mark(value, {
                        done: count => {
                            if (count) {
                                resultsCount += count;
                                matched.push(a);
                            } else {
                                nomatched.push(a);
                            }

                            if (nomatched.length === accordions.length) {
                                emptyTag.innerHTML = `“<strong>${value}</strong>”`;
                                emptyMessage.style.display = 'block';

                                return;
                            }

                            if (matched.length + nomatched.length === accordions.length) {
                                resultTag.innerHTML = `${resultsCount} ${resultsCount === 1 ? 'result' : 'results'} for: <strong>“${value}”</strong>`;
                                resultMessage.style.display = 'block';

                                matched.forEach(m => {
                                    m.style.display = 'block';
                                    m.setAttribute('open', '');
                                    const panel = m.closest('[data-division-panel]');
                                    if (panel) {
                                        panel.hidden = false;
                                    }
                                });
                            }
                        },
                    });
                },
            });
        });
    }, 500);

    [resultReset, emptyReset].forEach(r => {
        r.onclick = () => {
            searchInput.value = '';
            searchInput.onkeyup();
        };
    });
}
